import React, { useEffect, useState } from "react";
import styles from "../../styles/layout/DashboardHeader.module.scss";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenueBar from "../../assets/menu.png";
import searchIcon from "../../assets/searchicon.png";
import { GetProfileDetails } from "../../api/functions/user.api";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import CustomInput from "../../components/CustomInput/CustomInput";
import useNotiStack from "../../hooks/useNotistack";
import BasicModal from "../../ui/Modal/Modal";
import { setAdminUserDetails } from "../../redux-toolkit/slices/adminUserSlice";
import dropdownIcon from "../../assets/dropdownArrow.png";
import { GetMCMemeberList } from "../../api/functions/MCMember.api";
import { setLoadingState, setMemberLists } from "../../redux-toolkit/slices/MCMemberSlice";
import BrandMotocaddylogo from "../../assets/MOTOCADDYLogo.png";
import CrossIcon from "../../assets/close.png"
import { adminMemberData, adminUserId } from "../../services/utils";




export default function DashboardHeader() {
  const dispatch = useDispatch()
 const { toastInfo, toastError } = useNotiStack();
 const navigate = useNavigate();
 const user = adminMemberData();
 const currentPath = window.location.pathname;
 const userId = adminUserId();
 const [inputValue, setInputvalue]= useState();
 const [openLogoutModal,setOpenLogoutmodal] = useState(false);

 const [anchorElDrop, setAnchorElDrop] = React.useState(null);
 const [searchByName, setSearchByName] = useState(false)
 const [searchByEmail, setSearchByEmail] = useState(false)
 const [searchBySerialNo, setSearchBySerialNo] = useState(false)
 const [searchByFirstName, setSearchByFirstName] = useState(false);
 const [searchByLastName, setSearchByLastName] = useState(false);
 const [inputForFirstName, setInputForFirstName] = useState()
 const [inputForLastName, setInputForLastName] = useState()
 const [searchByFullName, setSearchByFullName] = useState(false)
 

 const [anchorEl, setAnchorEl] = React.useState(null);
 const open = Boolean(anchorEl);


 const openDrop = Boolean(anchorElDrop);
 const handleClickDrop = (event) => {
  setAnchorElDrop(event.currentTarget);
 
 };
 const handleCloseDrop = () => {
  setAnchorElDrop(null);
 };

const handleSearchName = ()=>{
  setAnchorElDrop(null);
  setSearchByName(true)
  setSearchByFirstName(true)
  setSearchByLastName(true)
  setSearchByEmail(false)
  setSearchBySerialNo(false)

  setSearchByFullName(true)
}
const handleSearchEmail = ()=>{
  setAnchorElDrop(null);
  setSearchByEmail(true)
  setSearchByName(false)
  setSearchBySerialNo(false)
  setSearchByFirstName(false)
  setSearchByLastName(false)

  setSearchByFullName(false)
  setInputForFirstName(null)
  setInputForLastName(null)
  setInputvalue(null)
}
const handleSearchSerialNo = ()=>{
  setAnchorElDrop(null);
  setSearchBySerialNo(true)
  setSearchByName(false)
  setSearchByEmail(false)
  setSearchByFirstName(false)
  setSearchByLastName(false)

  setSearchByFullName(false)
  setInputvalue(null)
}


const { refetch, isFetching } = useQuery(
  ["memberList"],
  async () => GetMCMemeberList(
    searchByFullName ? { firstName: inputForFirstName, lastName: inputForLastName } :
    searchByFirstName ? { firstName: inputForFirstName } :
    searchByLastName ? { lastName: inputForLastName } :
    searchByEmail ? { email: inputValue } : { serialNumber: inputValue }
  ),
  {
    enabled: false,
    onSuccess: (res) => {
      dispatch(setMemberLists(res))
      if(res?.memberList?.length === 1){
        navigate(`/dashboard/search-detailed/${res?.memberList[0]?.id_member}`)
      }
     
    },
    onError: (res) => {
      toastError("Something went wrong")
    },
  }
);


const profileDetailsQuery = useQuery(
  ["userdetails"],
  () => GetProfileDetails({id_adminuser: Number(userId)}, user), 
  {
    onSuccess: (res) => {
      if (res?.Status === 1) {
       
        dispatch(setAdminUserDetails(res));
      }
    },
    onError: (res) => {
      toastError("Something went wrong")
    },
  }
);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const redirectToCustomer =()=>{
   navigate("/dashboard/search-results")
  }

  const redirectToProfile =()=>{
    navigate("/dashboard/user-profile")
  }

  const handleConfirmLogout =()=>{
    setOpenLogoutmodal(true)
  }
 const closeModal =()=>{
  setOpenLogoutmodal(false)
  setAnchorEl(null);
 }
  const handleLogout =()=>{
    localStorage.clear();
    toastInfo("Logout Successfully")
  window.location.reload()
  navigate("/")
  }
  const handleChange =(e)=>{
    setInputvalue(e.target.value)
  }


 const btnClick =()=>{
  navigate("/dashboard/search-results")
 }

const handleFirstName = (e)=>{
setInputForFirstName(e.target.value)
}
const handleLastName = (e)=>{
  setInputForLastName(e.target.value)
}

useEffect(() => {
  dispatch(setLoadingState(isFetching))
}, [isFetching])

const handleKeyDown = (e)=>{
  if(e.keyCode === 13){
    refetch()
  }
}

  return (
    <Box className={styles.dashboardHeaderWrap}>
      <Button className={styles.logo} onClick={btnClick}>
        <img src={BrandMotocaddylogo} alt="brandlogo" />
      </Button>
      <Box className={styles.appbarbutton}>
        <Box className={styles.admindetails}>
          {profileDetailsQuery?.isSuccess && profileDetailsQuery?.data?.Status === 1 ? (<>
            <Typography variant="body1" className={styles.userName}>{profileDetailsQuery?.data?.firstName} {profileDetailsQuery?.data?.lastName}</Typography>
          <Typography variant="caption" className={styles.userRole}> {profileDetailsQuery?.data?.administrator === 1 ? "Super Admin" : "General Admin" }</Typography>
          </>):(<>
            <Typography variant="body1">--</Typography>
          <Typography variant="caption">--</Typography>
          </>)}
      
        </Box>
        <Button
        disableRipple
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          className={styles.menu_btn}
        >
          <i>
            <img src={MenueBar} alt="Brandlogo" />
          </i>
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
  
          classes={{ paper: styles.user_menu }}
        >
          <MenuItem onClick={redirectToCustomer}>Customers</MenuItem>
          <MenuItem onClick={redirectToProfile}>Profile</MenuItem>
          <MenuItem onClick={handleConfirmLogout}>Logout</MenuItem>

        </Menu>
        <BasicModal open={openLogoutModal} 
          onClose={closeModal} 
          content="Are you sure? You want to logout!" 
          warningIconPreview 
          noBtnClick={closeModal}
          yesBtnClick={handleLogout} />
      </Box>
     {currentPath === "/dashboard/search-results" &&   <Box className={styles.searchbox}> 
     

          {!searchByName ? 
            <Box className={styles.form_search}>
            <CustomInput value={inputValue || ""} onChange={handleChange} onKeyDown={handleKeyDown}
             placeholder={searchByEmail ? "Enter email" : searchBySerialNo ? "Enter serial no" : "Please select search parameter"  }
            disabled={!searchByName && !searchByEmail && !searchBySerialNo}
              />
            <Button className={styles.seach_icon}>
              <img src={searchIcon} alt="" />
            </Button>
          </Box>
          : 
          <Box className={styles.input_grp}>
            {searchByFirstName &&   
               <Box className={styles.input_field}>
            <input type="text" value={inputForFirstName || ""} onKeyDown={handleKeyDown} onChange={handleFirstName} placeholder="first name" />
            {searchByLastName && <button type="button" onClick={()=> {setSearchByFirstName(false);setSearchByFullName(false)}}  className={styles.cross_icon}>
             <img src={CrossIcon} alt="" />
            </button>}
            </Box>}
        
             {searchByLastName && 
                  <Box className={styles.input_field}>
                  <input type="text" value={inputForLastName || ""} onKeyDown={handleKeyDown} onChange={handleLastName} placeholder="last name" />
                {searchByFirstName && <button type="button" onClick={()=> {setSearchByLastName(false);setSearchByFullName(false)}}  className={styles.cross_icon}>
                  <img src={CrossIcon} alt="" />
                  </button>} 
                  </Box>
          }

       
            <img src={searchIcon} alt="" className={styles.search_icon}/>
            </Box>
          }

       
        
        <Button 
        id="basic-button" disableRipple disableFocusRipple 
        aria-controls={openDrop ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openDrop ? 'true' : undefined}
        onClick={handleClickDrop} 
        className={styles.searchBtn}
        style={{position: "absolute", top: "6px", right: "-10px"}}
      >
        <img src={dropdownIcon}  width={25} alt="" 
         
        />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorElDrop}
        open={openDrop}
        onClose={handleCloseDrop}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={handleSearchName}>Member Name</MenuItem>
        <MenuItem onClick={handleSearchEmail}>Email</MenuItem>
        <MenuItem  onClick={handleSearchSerialNo}>Serial Number</MenuItem>
      </Menu>
      </Box>
      }
    </Box>
  );
}
